import { Recurso, UseCaseRecursoAsync } from "lib.common/dist/CleanArch";
import { ErrDevGenerico } from "lib.common/dist/errorHandler";
import { ProductoTiendaDsKey } from "../entities/ProductoTiendaDsKey";
import { AddDeleteCodProdTIendaParams } from "../../utils/params/CodProdTIendaParams";
import { GestionarCodProdTiendaRepository } from "../repositories/GestionarCodProdTiendaRepository";

export class AddCodProductoTiendaUseCase<
    T_OUT extends ProductoTiendaDsKey
> extends UseCaseRecursoAsync<AddDeleteCodProdTIendaParams, T_OUT> {
    private repository: GestionarCodProdTiendaRepository<T_OUT>;
    constructor(repository: GestionarCodProdTiendaRepository<T_OUT>) {
        super();
        this.repository = repository;
    }

    async call(
        input: AddDeleteCodProdTIendaParams
    ): Promise<Recurso<T_OUT>> {
        try {
            return await this.repository.addCodProductoTienda(input);
        } catch (error) {
            const errorCapa = new ErrDevGenerico(error as Error);
            return Recurso.fromError<T_OUT>(errorCapa);
        }
    }
}